<div>
    <div class="content">
        <list-view [liste]="fournisseurListView" *ngIf="fournisseurListView"></list-view>
    </div>
    <floating-button *ngIf="listeActions?.value" [listeActions]="listeActions"></floating-button>
</div>
